export const emailValidator = (value: unknown) => {
  if (typeof value !== 'string') {
    return null;
  }

  const isValid =
    /^[=_0-9a-z+~'!$&*^`|#%/?{}-]+(\.[=_0-9a-z+~'!$&*^`|#%/?{}-]+)*@(([-0-9a-z_]+\.)+)([a-z0-9-]{2,20})$/.test(value);

  return !isValid;
};
